import React from 'react';
import { Product, WheelProduct } from '../../../../../types';
import ProductCard from './ProductCard';
import WheelProductItem from './WheelProductItem';

interface ProductManagementContentProps {
  products: Product[];
  wheelProducts: WheelProduct[];
  isSubmitting: boolean;
  onAddProduct: (product: Product, oddsWeight: number) => void;
  onUpdateOddsWeight: (productId: number, oddsWeight: number) => void;
  onRemoveProduct: (productId: number) => void;
  onSave: () => void;
}

const ProductManagementContent: React.FC<ProductManagementContentProps> = ({
  products,
  wheelProducts,
  isSubmitting,
  onAddProduct,
  onUpdateOddsWeight,
  onRemoveProduct,
  onSave
}) => {
  const availableProducts = products.filter(
    product => !wheelProducts.some(wp => wp.id === product.id)
  );

  return (
    <div className="space-y-6">
      {availableProducts.length > 0 && (
        <div className="pb-6 border-b border-tinta/10">
          <h3 className="font-display text-lg font-bold text-tinta mb-4">
            Adicionar Produtos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {availableProducts.map(product => (
              <ProductCard
                key={product.id}
                product={product}
                onAdd={(oddsWeight) => onAddProduct(product, oddsWeight)}
              />
            ))}
          </div>
        </div>
      )}

      <div>
        <h3 className="font-display text-lg font-bold text-tinta mb-4">
          Produtos no Sorteio
        </h3>
        {wheelProducts.length === 0 ? (
          <div className="text-center py-10 bg-white rounded-xl border border-tinta/10">
            <p className="text-tinta-soft italic">
              Nenhum produto adicionado ainda
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {wheelProducts.map(wheelProduct => (
              <WheelProductItem
                key={wheelProduct.id}
                wheelProduct={wheelProduct}
                onUpdateOddsWeight={(oddsWeight) => onUpdateOddsWeight(wheelProduct.id, oddsWeight)}
                onRemove={() => onRemoveProduct(wheelProduct.id)}
              />
            ))}
          </div>
        )}
      </div>

      {wheelProducts.length > 0 && (
        <div className="flex justify-end pt-4 border-t border-tinta/10">
          <button
            disabled={isSubmitting}
            onClick={onSave}
            className="px-4 py-2 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark focus:outline-none focus:ring-2 focus:ring-bordo/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Salvando...' : 'Salvar Produtos'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductManagementContent;
